// One fax draft, as listed under Drafts in the Fax Manager and at the top of a
// client's Faxes tab: what it is, who it's to, who last touched it. Resume
// reopens the window exactly as it was left; Discard asks twice.
import { useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { DRAFT_KIND_LABEL, discardFaxDraft } from '../../lib/faxDrafts';

const fmtFax = (d) => d && d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : (d || '');

export default function FaxDraftRow({ draft, showClient, onResume, onChanged, last }) {
  const [armed, setArmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const client = draft.clients;
  const files = (draft.staged_files || []).length + ((draft.state?.picked || draft.state?.attached || []).length);

  const discard = async () => {
    if (!armed) { setArmed(true); setTimeout(() => setArmed(false), 5000); return; }
    setBusy(true); setErr('');
    try { await discardFaxDraft(draft.id); onChanged?.(); }
    catch (e) { setErr(e.message || 'Could not discard.'); setBusy(false); }
  };

  return (
    <div style={{ display: 'flex', gap: 14, padding: '12px 0', borderBottom: last ? 'none' : '1px solid var(--border)', alignItems: 'flex-start' }}>
      <div title="Draft — not sent" style={{ width: 34, height: 34, borderRadius: 8, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--warn-bg)', border: '1px solid var(--border)', fontSize: 15 }}>
        📝
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)' }}>{draft.title || DRAFT_KIND_LABEL[draft.kind]}</span>
          <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 20, background: 'var(--warn-bg)', color: 'var(--warn)', whiteSpace: 'nowrap' }}>Draft</span>
          <span style={{ fontSize: 12, color: 'var(--text3)' }}>{DRAFT_KIND_LABEL[draft.kind]}</span>
          {showClient && client && (
            <span style={{ fontSize: 12, color: 'var(--accent)' }}>{client.last_name}, {client.first_name} <span style={{ fontFamily: 'monospace', color: 'var(--text3)' }}>{client.client_id}</span></span>
          )}
        </div>
        <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>
          {draft.recipient_name ? <>to {draft.recipient_name}{draft.recipient_fax ? ` · ${fmtFax(draft.recipient_fax)}` : ''}</> : 'No recipient yet'}
          {files > 0 ? ` · ${files} file${files === 1 ? '' : 's'}` : ''}
          {' · '}edited {formatDistanceToNow(new Date(draft.updated_at), { addSuffix: true })}{draft.updated_by_name ? ` by ${draft.updated_by_name}` : ''}
        </div>
        {err && <div style={{ fontSize: 12, color: 'var(--danger)', marginTop: 4 }}>{err}</div>}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-end', flexShrink: 0 }}>
        <button className="btn btn-primary btn-sm" onClick={() => onResume(draft)} disabled={busy}>Resume</button>
        <button className="btn btn-ghost btn-sm" onClick={discard} disabled={busy} style={{ fontSize: 11, color: armed ? 'var(--danger)' : 'var(--text3)' }}>
          {armed ? 'Click again to discard' : 'Discard'}
        </button>
      </div>
    </div>
  );
}
